import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Sidebar({
  categories,
  isMenuOpen,
  setIsMenuOpen,
  selectedCategory,
  setSelectedCategory,
  theme,
  toggleTheme,
}) {
  return (
    <aside
      className={`
        fixed lg:static inset-y-0 left-0 z-50
        w-72 bg-white dark:bg-dark-card
        border-r border-gray-200 dark:border-gray-700
        transform transition-transform duration-300
        ${isMenuOpen ? "translate-x-0" : "-translate-x-full"}
        lg:translate-x-0
        flex flex-col
      `}
    >
      {/* HEADER */}
      <div className="p-6 flex justify-between items-center border-b border-gray-200 dark:border-gray-700">
        <h1 className="text-xl font-bold uppercase text-gray-900 dark:text-gray-100">
          Imagenerate
        </h1>

        <div className="flex items-center gap-2">
          {/* Close button for mobile */}
          <button
            onClick={() => setIsMenuOpen(false)}
            className="lg:hidden text-2xl text-gray-700 dark:text-gray-300"
          >
            <FontAwesomeIcon icon={["fas", "times"]} />
          </button>

          {/* Theme toggle button */}
          <button
            onClick={toggleTheme}
            className="text-xl p-2 rounded hover:bg-gray-100 dark:hover:bg-dark-hover transition"
          >
            <FontAwesomeIcon icon={["fas", theme === "dark" ? "sun" : "moon"]} />
          </button>
        </div>
      </div>

      {/* CATEGORY LIST */}
      <nav className="flex-1 overflow-y-auto p-2">
        {categories.map(cat => (
          <button
            key={cat.name}
            onClick={() => {
              setSelectedCategory(cat);
              setIsMenuOpen(false);
            }}
            className={`w-full text-left px-4 py-3 rounded-lg flex items-center gap-2 ${
              selectedCategory?.name === cat.name
                ? "bg-indigo-600 text-white"
                : "hover:bg-gray-100 dark:hover:bg-dark-hover text-gray-900 dark:text-gray-100"
            }`}
          >
            <FontAwesomeIcon icon={["fas", cat.icon]} />
            {cat.name}
          </button>
        ))}
      </nav>
    </aside>
  );
}
